import { render } from "./MobilityTrainBusCard.vue?vue&type=template&id=4798032d&scoped=true"
import script from "./MobilityTrainBusCard.vue?vue&type=script&lang=js"
export * from "./MobilityTrainBusCard.vue?vue&type=script&lang=js"

import "./MobilityTrainBusCard.vue?vue&type=style&index=0&id=4798032d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4798032d"]])

export default __exports__